module.exports = __webpack_public_path__ + "images/wappen-harmonie-muenchen-0d4b6ff5ba89d8b41aff25a3c0cd9490.png";